import {
  GUEST_ACCESS_MESSAGE,
} from '@/creditflowresearch/application/BondScreener/Sidebar/bondScreenerViewsConstants';

export const getAccessTooltip = (
  isRestricted: boolean,
  isActionAvailable: boolean,
  unavailableMessage: string,
): string | undefined => {
  if (isRestricted) {
    return GUEST_ACCESS_MESSAGE;
  }

  return isActionAvailable ? undefined : unavailableMessage;
};
